module.exports = __webpack_public_path__ + "static/img/Motn-MC-P.510beef8.jpg";